export interface LiveUpdateApplyState {
  /** True while the user is actively editing the playlist. */
  isEditing: boolean;
  /** Non-empty while a local save is still in flight. */
  lastSaveAttempt: string;
}

/**
 * Decides whether a remote (Firestore) playlist update should be pulled into the
 * local editor. It may only be applied when the user is neither editing nor
 * waiting on a save — otherwise a live update would clobber unsaved local work.
 *
 * This rule regressed in commit 4366d1c: the subscription guard was inverted to
 * `!isEditing`, which contradicted the `!isEditing` apply-condition in
 * fetchAndSetPlaylistData, so live updates never applied at all. Keeping the
 * rule in one tested place stops that inversion from creeping back.
 */
export const shouldApplyLiveUpdate = ({
  isEditing,
  lastSaveAttempt,
}: LiveUpdateApplyState): boolean => !isEditing && lastSaveAttempt === "";
